"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Button = __importStar(require("./A_Button"));
var ListGrouping = __importStar(require("./M_ListGrouping"));
var icons_1 = require("./icons");
var Component = function (p) {
    return (Preact.h(Box_1.default, { bgcolor: "background.default", borderRadius: "8px", sx: { paddingBottom: '16px' } },
        Preact.h(ListGrouping.Component, { subheader: "No items", price: p.price }),
        Preact.h(Box_1.default, { display: "flex", flexDirection: "column", alignItems: "center", sx: { paddingX: '16px' } },
            Preact.h(Typography_1.default, { variant: "body1", textAlign: "center", sx: { paddingTop: '14px', paddingBottom: '24px' } },
                "Your space is currently empty, click the button below to start ",
                Preact.h("br", null),
                "adding items."),
            Preact.h(Button.Component, { variant: "contained", size: "medium", startIcon: Preact.h(icons_1.AddIcon, null), onClick: p.onAddClick, sx: {
                    height: '36px',
                    padding: '6px 16px',
                    fontSize: '14px',
                } }, "Add items"))));
};
exports.Component = Component;
